import { FormPin, FormPinValidation, FormStage, Loader } from 'BreetComponents';
import { alwaysRefetchApiQueryOptions } from 'BreetHelpers';
import { useFormStage } from 'BreetHooks';
import { useGetUserPreferenceQuery } from 'BreetRedux';
import { useEffect } from 'react';

import { type IAccessCredentialComponentProps, type PINFORMSTAGE } from '../DialogAccessCredentials.helpers';

const Pin = ({ type, dispatchAccessCredentials, error, clearError }: IAccessCredentialComponentProps) => {
	const { navigator, isStageInactive, stage } = useFormStage<PINFORMSTAGE>('verify-pin', ['create-pin', 'verify-pin']);

	const { data: userPreferenceData, isLoading: userPreferenceLoading } = useGetUserPreferenceQuery(
		undefined,
		alwaysRefetchApiQueryOptions
	);

	const userPreference = userPreferenceData?.data;

	useEffect(() => {
		if (!userPreferenceLoading) {
			navigator.reset();
			navigator.goTo(userPreference?.setups?.activatePin ? 'verify-pin' : 'create-pin')();
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [userPreference, userPreferenceLoading]);

	const wrapperClass = `accesscredentialspinform${stage === 'verify-pin' ? ' no-padding' : ''} bg-primary-500`;

	if (userPreferenceLoading)
		return (
			<div className='modal-loader bg-neutral-50'>
				<Loader />
			</div>
		);

	return (
		<div className={wrapperClass}>
			<FormStage hide={isStageInactive('create-pin')}>
				<FormPin
					mode='create'
					onSuccess={navigator.goTo('verify-pin')}
				/>
			</FormStage>

			<FormStage hide={isStageInactive('verify-pin')}>
				<FormPinValidation
					onSuccess={dispatchAccessCredentials}
					type={type}
					error={error}
					clearError={clearError}
				/>
			</FormStage>
		</div>
	);
};

export default Pin;
